// This function is used to get array elements safely by hard-coded index - so we can be sure the index always
// exists. This is not to be used dynamically - rather to retrieve, for example, default option from an array of
// options.
export const getArrayElement = <AE>(array: AE[], index: number): AE => {
  if (array[index] !== undefined) {
    return array[index] as AE;
  }
  throw new Error('Expected hard-coded index does not exist in array.');
};
